module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/select2/select2-single/select2-single.component.scss
// module id = ./src/app/components/tools/select2/select2-single/select2-single.component.scss
// module chunks = main